export default {"src":"/_next/static/media/ellipse4.2d0997f5.svg","height":176,"width":176};